<template>
    <v-dialog
        :model-value="visible"
        :max-width="maxWidth"
        persistent
        @update:model-value="$emit('update:visible', $event)"
    >
        <v-card>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-card-title>{{ title }}</v-card-title>
                    </v-col>
                    <v-col cols="12">
                        <v-card-text>
                            <slot name="default">{{ message }}</slot>
                        </v-card-text>
                    </v-col>
                    <v-col cols="12">
                        <v-row dense class="ma-0">
                            <v-col cols="6" class="pa-1">
                                <v-btn block variant="flat" :color="secondaryColor" @click="$emit('secondary')">
                                    {{ secondaryText }}
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="pa-1">
                                <v-btn block variant="flat" :color="primaryColor" @click="$emit('primary')">
                                    {{ primaryText }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        title: { type: String, default: "" },
        message: { type: String, default: "" },
        primaryText: { type: String, default: "Yes" },
        secondaryText: { type: String, default: "No" },
        secondaryColor: { type: String, default: "error" },
        primaryColor: { type: String, default: "primary" },
        maxWidth: { type: [String, Number], default: 480 },
    },
    emits: ["update:visible", "primary", "secondary"],
};
</script>
